import styled from "styled-components"
import { space, grid, compose } from "styled-system"
import Div from "../div/div.component"
import { GatsbyImage } from "gatsby-plugin-image"

export const ImageStatsContainer = styled.div`
  display: flex;
  gap: 60px;
  flex-wrap: wrap;
  margin-top: 17px;

  @media screen and (max-width: 1040px) {
    gap: 40px;
  }
`

export const ImageStatsInnerContainer = styled.div`
  display: flex;
  @media screen and (max-width: 780px) {
    flex-direction: column;
  }
`

export const StatsImage = styled(GatsbyImage)`
  width: 75px;
  height: 75px;

  @media screen and (max-width: 780px) {
    width: 60px;
    height: 60px;
  }
`

export const PageHeroContainer = styled.header`
  grid-column: 6 / 1;
  margin-bottom: 40px;
  ${compose(space, grid)};
`
PageHeroContainer.displayName = "PageHeroContainer"

export const PageHeroTitle = styled.h1`
  margin: 0;
  ${({ theme: { typography } }) => typography.desktop.h1};
  @media screen and (max-width: 780px) {
    ${({ theme: { typography } }) => typography.mobile.h1};
  }
`

PageHeroTitle.displayName = "PageHeroTitle"

export const PageHeroDescription = styled(Div)`
  ${space};

  & a {
    color: ${({ theme: { colors } }) => colors.hyperLinkPink};
  }

  @media screen and (max-width: 780px) {
    ${({ theme: { typography } }) => typography.mobile.largeInlineCTA};
  }
`

PageHeroDescription.displayName = "PageHeroDescription"
